class DawnProductOptions {
  constructor() {
    this.optionsContainer = document.querySelector('.section__custom-option');
    this.productForm = this.findProductForm();
    this.addToCartButton = this.findAddToCartButton();
    this.buyNowButton = this.findBuyNowButton();
    this.variantInput = this.findVariantInput();
    this.quantityInput = this.productForm?.querySelector('[name="quantity"]');
    
    if (!this.optionsContainer || !this.productForm) {
      console.warn('必要な要素が見つかりません');
      return;
    }
    
    this.init();
  }
  
  findVariantInput() {
    if (!this.productForm) return null;
    
    const selectors = [
      '[name="id"]',
      '[data-product-select]',
      'select[name="id"]',
      'input[name="id"]'
    ];
    
    for (const selector of selectors) {
      const input = this.productForm.querySelector(selector);
      if (input && input.value) {
        console.log(`Variant input found with selector: ${selector}`, input, 'value:', input.value);
        return input;
      }
    }
    
    console.warn('Variant input not found or has no value. Available inputs:', this.productForm.querySelectorAll('input, select'));
    return null;
  }
  
  init() {
    this.setupOptionSelection();
    this.setupAddToCartButton();
    this.setupBuyNowButton();
    
    console.log('DawnProductOptions initialized', {
      productForm: !!this.productForm,
      addToCartButton: !!this.addToCartButton,
      buyNowButton: !!this.buyNowButton,
      variantInput: !!this.variantInput,
      quantityInput: !!this.quantityInput,
      options: this.optionsContainer.querySelectorAll('.option-item').length,
      variantValue: this.variantInput?.value,
      quantityValue: this.quantityInput?.value
    });
    
    // 要素が見つからない場合の詳細ログ
    if (!this.addToCartButton) {
      console.warn('Add to cart button not found. Trying alternative selectors...');
      console.log('Available buttons:', document.querySelectorAll('button, [type="submit"]'));
    }
    
    if (!this.buyNowButton) {
      console.warn('Buy now button not found. Looking for:', '#buy-now-button');
    }
    
    if (!this.variantInput) {
      console.warn('Variant input not found. Available inputs:', this.productForm?.querySelectorAll('input'));
    }
  }
  
  findProductForm() {
    // Dawn テーマの product-form カスタム要素を優先
    const productFormElement = document.querySelector('product-form');
    if (productFormElement) {
      return productFormElement.querySelector('form');
    }
    
    // フォールバック
    return document.querySelector('form[action*="/cart/add"]');
  }
  
  findAddToCartButton() {
    // 複数のセレクタを順番に試す
    const selectors = [
      '[id*="ProductSubmitButton"]',
      '[name="add"]',
      'button[type="submit"]',
      '.product-form__cart-submit',
      '.btn--add-to-cart'
    ];
    
    for (const selector of selectors) {
      const button = this.productForm?.querySelector(selector) || document.querySelector(selector);
      if (button) {
        console.log(`Add to cart button found with selector: ${selector}`, button);
        return button;
      }
    }
    
    console.warn('Add to cart button not found with any selector');
    return null;
  }
  
  findBuyNowButton() {
    const selectors = [
      '#buy-now-button',
      '.buy-now-button',
      '[data-buy-now]'
    ];
    
    for (const selector of selectors) {
      const button = document.querySelector(selector);
      if (button) {
        console.log(`Buy now button found with selector: ${selector}`, button);
        return button;
      }
    }
    
    console.warn('Buy now button not found with any selector');
    return null;
  }
  
  setupOptionSelection() {
    const optionItems = this.optionsContainer.querySelectorAll('.option-item');
    
    optionItems.forEach(item => {
      const input = item.querySelector('input');
      if (!input) return;
      
      // アイテム全体のクリックイベント（元コードの動作を再現）
      item.addEventListener('click', () => {
        this.handleOptionClick(input, item);
      });
    });
  }
  
  handleOptionClick(input, item) {
    const inputType = input.type;
    
    if (inputType === 'radio') {
      // ラジオボタンの場合は同じname属性のものをすべて未選択に
      const name = input.name;
      document.querySelectorAll(`input[name="${name}"]`).forEach(radio => {
        radio.checked = false;
        const radioItem = radio.closest('.option-item');
        if (radioItem) {
          radioItem.classList.remove('selected');
        }
      });
      
      // クリックされたものを選択状態に
      input.checked = true;
      item.classList.add('selected');
      
    } else if (inputType === 'checkbox') {
      // チェックボックスの場合は状態を切り替え
      input.checked = !input.checked;
      item.classList.toggle('selected', input.checked);
    }
    
    console.log(`Option ${input.name}: ${input.checked ? 'selected' : 'deselected'}`);
  }
  
  setupAddToCartButton() {
    if (!this.addToCartButton) {
      console.warn('Add to cart button not found');
      return;
    }
    
    // カート追加ボタンには一切手を加えず、オプション商品の追加のみを後から実行
    const productFormElement = document.querySelector('product-form');
    if (productFormElement) {
      // 元のフォーム送信は阻止せず、送信後にオプション商品を追加
      productFormElement.addEventListener('submit', () => {
        const selectedOptions = this.getSelectedOptions();
        
        if (selectedOptions.length > 0) {
          // 元の処理が完了した後にオプション商品を追加
          setTimeout(() => {
            this.addOptionsToCartOnly();
          }, 500);
        }
      });
    }
  }
  
  async addOptionsToCartOnly() {
    const selectedOptions = this.getSelectedOptions();
    
    if (selectedOptions.length === 0) {
      console.log('No options selected');
      return;
    }
    
    console.log('Adding option products to cart:', selectedOptions);
    
    try {
      // オプション商品のみを追加
      const optionItems = selectedOptions.map(option => ({
        id: parseInt(option.variantId),
        quantity: 1
      }));
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: optionItems })
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        console.error('Failed to add option products:', errorData);
        return;
      }
      
      console.log('Option products added successfully');
      
      // カート更新イベントを再発火
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      // オプション商品も含めたカート通知を表示
      setTimeout(() => {
        this.showCartNotificationWithOptions();
      }, 300);
      
    } catch (error) {
      console.error('Error adding option products:', error);
    }
  }
  
  async showCartNotificationWithOptions() {
    try {
      // 最新のカート情報を取得
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // cart-notification要素を取得
      const cartNotification = document.querySelector('cart-notification');
      const cartNotificationProduct = document.querySelector('#cart-notification-product');
      
      if (!cartNotification || !cartNotificationProduct) {
        console.log('Cart notification elements not found');
        return;
      }
      
      // 追加された商品の情報を構築
      const addedItems = this.buildCartItemsForNotification();
      let notificationHTML = '';
      
      // メイン商品とオプション商品を区別して表示
      const mainItem = addedItems[0]; // 最初がメイン商品
      const optionItems = addedItems.slice(1); // 残りがオプション商品
      
      // メイン商品を表示
      const mainCartItem = cart.items.find(cartItem => cartItem.variant_id === parseInt(mainItem.id));
      if (mainCartItem) {
        notificationHTML += `
          <div class="cart-notification-product__item">
            ${this.buildCartNotificationItemHTML(mainCartItem, false)}
          </div>
        `;
      }
      
      // オプション商品を表示
      if (optionItems.length > 0) {
        notificationHTML += `<div class="cart-notification-product__options">`;
        notificationHTML += `<h4 class="cart-notification__subtitle">追加オプション</h4>`;
        
        for (const optionItem of optionItems) {
          const optionCartItem = cart.items.find(cartItem => cartItem.variant_id === parseInt(optionItem.id));
          if (optionCartItem) {
            notificationHTML += `
              <div class="cart-notification-product__option-item">
                ${this.buildCartNotificationItemHTML(optionCartItem, true)}
              </div>
            `;
          }
        }
        notificationHTML += `</div>`;
      }
      
      // 商品情報を表示
      cartNotificationProduct.innerHTML = notificationHTML;
      
      // カートボタンのテキストを更新
      const cartButton = document.querySelector('#cart-notification-button');
      if (cartButton && cart.item_count > 0) {
        cartButton.textContent = `カートを表示 (${cart.item_count}点)`;
      }
      
      // 通知を表示
      this.displayCartNotification(cartNotification);
      
    } catch (error) {
      console.error('Failed to show cart notification:', error);
    }
  }
  
  buildCartItemsForNotification() {
    const items = [];
    
    // メイン商品
    const mainVariantId = this.variantInput?.value;
    const quantity = parseInt(this.quantityInput?.value || '1');
    
    if (mainVariantId) {
      items.push({
        id: parseInt(mainVariantId),
        quantity: quantity
      });
    }
    
    // 選択されたオプション
    const selectedOptions = this.getSelectedOptions();
    selectedOptions.forEach(option => {
      if (option.variantId) {
        items.push({
          id: parseInt(option.variantId),
          quantity: 1
        });
      }
    });
    
    return items;
  }
  
  displayCartNotification(cartNotification) {
    const notification = document.querySelector('#cart-notification');
    
    if (!notification) return;
    
    // 通知を表示
    cartNotification.style.display = 'block';
    notification.style.display = 'block';
    
    // アニメーション用の初期値設定
    notification.style.opacity = '0';
    notification.style.transform = 'translateY(-20px)';
    
    // フェードイン効果
    requestAnimationFrame(() => {
      notification.style.transition = 'all 0.3s ease';
      notification.style.opacity = '1';
      notification.style.transform = 'translateY(0)';
    });
    
    // 通知をフォーカス
    notification.focus();
    
    // Dawnテーマのopen関数があれば実行
    if (typeof cartNotification.open === 'function') {
      cartNotification.open();
    }
  }
  
  buildCartNotificationItemHTML(cartItem, isOption = false) {
    const itemClass = isOption ? 'option-item' : 'main-item';
    
    return `
      <div class="cart-notification-product__image-wrapper ${itemClass}">
        <div class="cart-notification-product__image">
          <img src="${cartItem.image}" alt="${cartItem.product_title}" width="70" height="70" loading="lazy">
        </div>
        <div class="cart-notification-product__details">
          <h3 class="cart-notification-product__name h4">${cartItem.product_title}</h3>
          ${cartItem.variant_title && cartItem.variant_title !== 'Default Title' ? 
            `<p class="cart-notification-product__variant caption">${cartItem.variant_title}</p>` : ''}
        </div>
      </div>
    `;
  }
  
  formatMoney(cents) {
    // 簡単な価格フォーマット
    const amount = cents / 100;
    return new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: 'JPY'
    }).format(amount);
  }
  
  setupBuyNowButton() {
    if (!this.buyNowButton) {
      console.warn('Buy now button not found');
      return;
    }
    
    this.buyNowButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.handleBuyNow();
    });
  }
  
  async handleBuyNow() {
    const button = this.buyNowButton;
    
    if (!button) {
      console.error('Buy now button not found');
      return;
    }
    
    try {
      // buy-now-buttonのローディング状態のみ制御
      button.disabled = true;
      button.classList.add('loading');
      
      console.log('Clearing cart...');
      
      // カートをクリア
      const clearResponse = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      console.log('Cart clear response status:', clearResponse.status);
      
      if (!clearResponse.ok) {
        throw new Error(`Failed to clear cart: ${clearResponse.status}`);
      }
      
      // 少し待機
      await new Promise(resolve => setTimeout(resolve, 200));
      
      // メイン商品を追加
      const mainVariantId = this.variantInput?.value;
      const quantity = parseInt(this.quantityInput?.value || '1');
      
      if (!mainVariantId) {
        throw new Error('商品バリアントが選択されていません');
      }
      
      const mainItem = {
        id: parseInt(mainVariantId),
        quantity: quantity
      };
      
      console.log('Adding main product:', mainItem);
      
      const mainResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [mainItem] })
      });
      
      if (!mainResponse.ok) {
        const errorData = await mainResponse.json();
        console.error('Failed to add main product:', errorData);
        throw new Error(errorData.description || `HTTP Error: ${mainResponse.status}`);
      }
      
      // オプション商品を追加
      const selectedOptions = this.getSelectedOptions();
      if (selectedOptions.length > 0) {
        console.log('Adding option products:', selectedOptions);
        
        const optionItems = selectedOptions.map(option => ({
          id: parseInt(option.variantId),
          quantity: 1
        }));
        
        const optionResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: optionItems })
        });
        
        if (!optionResponse.ok) {
          console.warn('Failed to add some option products, but proceeding to checkout');
        }
      }
      
      console.log('Buy now successful, redirecting to checkout...');
      
      // チェックアウトページに遷移
      window.location.href = '/checkout';
      
    } catch (error) {
      console.error('Buy now error:', error);
      alert(`購入処理でエラーが発生しました: ${error.message}`);
    } finally {
      // buy-now-buttonのローディング状態を解除
      button.disabled = false;
      button.classList.remove('loading');
    }
  }
  
  buildCartItems() {
    const items = [];
    
    // デバッグ情報を詳細に出力
    console.log('Building cart items...', {
      variantInput: this.variantInput,
      variantValue: this.variantInput?.value,
      quantityInput: this.quantityInput,
      quantityValue: this.quantityInput?.value
    });
    
    // メイン商品
    const mainVariantId = this.variantInput?.value;
    const quantity = parseInt(this.quantityInput?.value || '1');
    
    console.log('Main product:', { mainVariantId, quantity });
    
    if (!mainVariantId) {
      console.error('No variant ID found. Available inputs:', this.productForm?.querySelectorAll('[name="id"], [data-product-select]'));
      throw new Error('商品バリアントが選択されていません');
    }
    
    items.push({
      id: parseInt(mainVariantId),
      quantity: quantity
    });
    
    // 選択されたオプション
    const selectedOptions = this.getSelectedOptions();
    console.log('Selected options:', selectedOptions);
    
    selectedOptions.forEach(option => {
      if (option.variantId) {
        items.push({
          id: parseInt(option.variantId),
          quantity: 1
        });
      }
    });
    
    console.log('Final cart items to add:', items);
    return items;
  }
  
  getSelectedOptions() {
    const options = [];
    
    // チェックされたラジオボタン
    this.optionsContainer.querySelectorAll('input[type="radio"]:checked').forEach(radio => {
      const variantId = radio.getAttribute('data-variant-id');
      if (variantId) {
        options.push({
          type: 'radio',
          name: radio.name,
          value: radio.value,
          variantId: variantId
        });
      }
    });
    
    // チェックされたチェックボックス
    this.optionsContainer.querySelectorAll('input[type="checkbox"]:checked').forEach(checkbox => {
      const variantId = checkbox.getAttribute('data-variant-id');
      if (variantId) {
        options.push({
          type: 'checkbox',
          name: checkbox.name,
          value: checkbox.value,
          variantId: variantId
        });
      }
    });
    
    return options;
  }
}

// ===== スタンドアロンの「購入する」ボタン機能 =====

// オプションがない場合の「購入する」ボタン設定
function setupStandaloneBuyNowButton() {
  const buyNowButton = document.getElementById('buy-now-button');
  if (!buyNowButton) {
    console.warn('Buy now button not found');
    return;
  }
  
  console.log('Setting up standalone buy now button');
  
  // 既にイベントリスナーが追加されている場合は重複を避ける
  if (buyNowButton.hasAttribute('data-standalone-setup')) {
    return;
  }
  buyNowButton.setAttribute('data-standalone-setup', 'true');
  
  buyNowButton.addEventListener('click', async (e) => {
    e.preventDefault();
    
    try {
      // ボタンのローディング状態
      buyNowButton.disabled = true;
      buyNowButton.classList.add('loading');
      
      console.log('Clearing cart...');
      
      // カートをクリア
      const clearResponse = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      if (!clearResponse.ok) {
        throw new Error(`Failed to clear cart: ${clearResponse.status}`);
      }
      
      // 少し待機
      await new Promise(resolve => setTimeout(resolve, 200));
      
      // 商品情報を取得
      const productForm = findProductFormForStandalone();
      const variantInput = findVariantInputForStandalone(productForm);
      const quantityInput = productForm?.querySelector('[name="quantity"]');
      
      const variantId = variantInput?.value || buyNowButton.getAttribute('data-variant-id');
      const quantity = parseInt(quantityInput?.value || '1');
      
      if (!variantId) {
        throw new Error('商品バリアントが選択されていません');
      }
      
      console.log('Adding product to cart:', { variantId, quantity });
      
      // 商品をカートに追加
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: quantity
          }]
        })
      });
      
      if (!addResponse.ok) {
        const errorData = await addResponse.json();
        console.error('Failed to add product:', errorData);
        throw new Error(errorData.description || `HTTP Error: ${addResponse.status}`);
      }
      
      console.log('Product added successfully, redirecting to checkout...');
      
      // チェックアウトページに遷移
      window.location.href = '/checkout';
      
    } catch (error) {
      console.error('Buy now error:', error);
      alert(`購入処理でエラーが発生しました: ${error.message}`);
    } finally {
      // ボタンのローディング状態を解除
      buyNowButton.disabled = false;
      buyNowButton.classList.remove('loading');
    }
  });
}

// スタンドアロン用のプロダクトフォーム検索
function findProductFormForStandalone() {
  // Dawn テーマの product-form カスタム要素を優先
  const productFormElement = document.querySelector('product-form');
  if (productFormElement) {
    return productFormElement.querySelector('form');
  }
  
  // フォールバック
  return document.querySelector('form[action*="/cart/add"]');
}

// スタンドアロン用のバリアント入力検索
function findVariantInputForStandalone(productForm) {
  if (!productForm) return null;
  
  const selectors = [
    '[name="id"]',
    '[data-product-select]',
    'select[name="id"]',
    'input[name="id"]'
  ];
  
  for (const selector of selectors) {
    const input = productForm.querySelector(selector);
    if (input && input.value) {
      console.log(`Variant input found with selector: ${selector}`, input, 'value:', input.value);
      return input;
    }
  }
  
  console.warn('Variant input not found or has no value');
  return null;
}

// ===== 初期化処理 =====

// 初期化
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.section__custom-option')) {
    // オプションがある場合
    window.dawnProductOptions = new DawnProductOptions();
  } else {
    // オプションがない場合でも「購入する」ボタンを設定
    setupStandaloneBuyNowButton();
  }
  
  setupCartNotificationButtons();
  patchDawnThemeCompatibility();
  enhanceProductInfoForBuyNowButton();
});

// セクション再読み込み時の初期化
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.section__custom-option')) {
    // オプションがある場合
    window.dawnProductOptions = new DawnProductOptions();
  } else {
    // オプションがない場合でも「購入する」ボタンを設定
    setupStandaloneBuyNowButton();
  }
  
  setupCartNotificationButtons();
  patchDawnThemeCompatibility();
  enhanceProductInfoForBuyNowButton();
});

// ===== その他のヘルパー関数群 =====

// product-info カスタム要素にbuy-now-button制御を追加
function enhanceProductInfoForBuyNowButton() {
  // 既存のproduct-infoがある場合は拡張
  const productInfoElements = document.querySelectorAll('product-info');
  
  productInfoElements.forEach(productInfo => {
    if (!productInfo.buyNowButtonEnhanced) {
      enhanceSingleProductInfo(productInfo);
      productInfo.buyNowButtonEnhanced = true;
    }
  });
  
  // 新しく追加されるproduct-infoも監視
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeName === 'PRODUCT-INFO' && !node.buyNowButtonEnhanced) {
          enhanceSingleProductInfo(node);
          node.buyNowButtonEnhanced = true;
        }
      });
    });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
}

function enhanceSingleProductInfo(productInfo) {
  // 元のhandleUpdateProductInfo関数を拡張（buy-now-button制御のみ）
  const originalHandleUpdateProductInfo = productInfo.handleUpdateProductInfo;
  
  if (originalHandleUpdateProductInfo) {
    productInfo.handleUpdateProductInfo = function(productUrl) {
      const originalCallback = originalHandleUpdateProductInfo.call(this, productUrl);
      
      return (html) => {
        // 元のコールバックを実行（カートに追加ボタンの制御はここで行われる）
        originalCallback(html);
        
        // buy-now-buttonの制御のみを追加
        updateBuyNowButtonState.call(this, html);
      };
    };
  }
  
  // 元のsetUnavailable関数を拡張（buy-now-button制御のみ）
  const originalSetUnavailable = productInfo.setUnavailable;
  
  if (originalSetUnavailable) {
    productInfo.setUnavailable = function() {
      // 元の処理を実行（カートに追加ボタンの制御はここで行われる）
      originalSetUnavailable.call(this);
      
      // buy-now-buttonを非表示にする
      setBuyNowButtonUnavailable();
    };
  }
}

function updateBuyNowButtonState(html) {
  const buyNowButton = document.getElementById('buy-now-button');
  if (!buyNowButton) return;
  
  // カートに追加ボタンの状態を参照（制御はしない）
  const addToCartButton = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
  const isAddToCartDisabled = addToCartButton?.hasAttribute('disabled') ?? true;
  
  // バリアントの情報を取得
  const variant = this.getSelectedVariant(html);
  const isVariantUnavailable = !variant || !variant.available;
  
  console.log('Updating buy-now-button state:', {
    isAddToCartDisabled,
    isVariantUnavailable,
    variant: variant?.id,
    available: variant?.available
  });
  
  // buy-now-buttonのみを制御
  if (isAddToCartDisabled || isVariantUnavailable) {
    // 売り切れまたは無効な場合は非表示
    buyNowButton.style.display = 'none';
    buyNowButton.setAttribute('disabled', 'disabled');
    buyNowButton.classList.add('disabled');
  } else {
    // 在庫ありの場合は表示
    buyNowButton.style.display = '';
    buyNowButton.removeAttribute('disabled');
    buyNowButton.classList.remove('disabled');
    
    // data-variant-idを更新
    if (variant?.id) {
      buyNowButton.setAttribute('data-variant-id', variant.id);
    }
  }
}

function setBuyNowButtonUnavailable() {
  const buyNowButton = document.getElementById('buy-now-button');
  if (!buyNowButton) return;
  
  console.log('Setting buy-now-button unavailable');
  
  buyNowButton.style.display = 'none';
  buyNowButton.setAttribute('disabled', 'disabled');
  buyNowButton.classList.add('disabled');
}

// バリアント変更イベントを監視（buy-now-button制御のみ）
document.addEventListener('DOMContentLoaded', () => {
  // PUB_SUB_EVENTSが利用可能な場合は使用
  if (window.PUB_SUB_EVENTS && window.subscribe) {
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, (data) => {
      console.log('Variant change detected:', data);
      
      const { variant } = data.data;
      const buyNowButton = document.getElementById('buy-now-button');
      
      if (!buyNowButton) return;
      
      // buy-now-buttonのみを制御
      if (!variant || !variant.available) {
        setBuyNowButtonUnavailable();
      } else {
        buyNowButton.style.display = '';
        buyNowButton.removeAttribute('disabled');
        buyNowButton.classList.remove('disabled');
        buyNowButton.setAttribute('data-variant-id', variant.id);
      }
    });
  }
  
  // フォールバック：カスタムイベントでも監視
  document.addEventListener('variant:change', (event) => {
    console.log('Custom variant change detected:', event.detail);
    
    const { variant } = event.detail;
    const buyNowButton = document.getElementById('buy-now-button');
    
    if (!buyNowButton) return;
    
    // buy-now-buttonのみを制御
    if (!variant || !variant.available) {
      setBuyNowButtonUnavailable();
    } else {
      buyNowButton.style.display = '';
      buyNowButton.removeAttribute('disabled');
      buyNowButton.classList.remove('disabled');
      buyNowButton.setAttribute('data-variant-id', variant.id);
    }
  });
});

// Dawnテーマとの互換性パッチ（buy-now-button制御のみ）
function patchDawnThemeCompatibility() {
  // html.getElementById パターンへの対応
  if (typeof window.html === 'undefined') {
    window.html = document;
  }
}

// buy-now-button状態取得のヘルパー関数
function getBuyNowButtonState(html, sectionId) {
  const doc = html || document;
  
  const addToCartButton = doc.getElementById ? 
    doc.getElementById(`ProductSubmitButton-${sectionId}`) : 
    document.getElementById(`ProductSubmitButton-${sectionId}`);
  
  const addToCartDisabled = addToCartButton?.hasAttribute('disabled') ?? true;
  
  // カートに追加ボタンの状態のみを参照
  return addToCartDisabled;
}

// グローバル関数として公開
window.getBuyNowButtonState = getBuyNowButtonState;

// カート通知のボタン処理を設定
function setupCartNotificationButtons() {
  // クローズボタン
  const closeButton = document.querySelector('.cart-notification__close');
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      hideCartNotification();
    });
  }
  
  // Continue shoppingボタン
  const continueButton = document.querySelector('.cart-notification__links .link.button-label');
  if (continueButton) {
    continueButton.addEventListener('click', () => {
      hideCartNotification();
    });
  }
}

function hideCartNotification() {
  const cartNotification = document.querySelector('cart-notification');
  const notification = document.querySelector('#cart-notification');
  
  if (cartNotification && notification) {
    notification.style.opacity = '0';
    notification.style.transform = 'translateY(-20px)';
    
    setTimeout(() => {
      notification.style.display = 'none';
      cartNotification.style.display = 'none';
    }, 300);
  }
}